import { AiOutlineArrowRight } from 'react-icons/ai'
import {BiErrorCircle} from 'react-icons/bi'

const ReactIcons = {
	rightArrow: AiOutlineArrowRight,
	error: BiErrorCircle,
}

export default ReactIcons